import { render, staticRenderFns } from "./InputCNPJ.vue?vue&type=template&id=31d8a219&scoped=true"
import script from "./InputCNPJ.vue?vue&type=script&lang=js"
export * from "./InputCNPJ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d8a219",
  null
  
)

export default component.exports